export type LeadScoreParams = {
  browser?: string;
  browserVersion?: string;
  caseUrgency: string;
  deviceModel?: string;
  deviceType: string;
  deviceVendor?: string;
  hasCampaign?: boolean;
  moreInfo?: string;
  osName?: string;
  osVersion?: string;
  serviceType: string;
  sessionStartTime?: Date;
  visitsCount?: number;
};

export type Intent = "low" | "medium" | "high";

export const ELIGIBLE_LEAD_INTENTS: Set<Intent> = new Set(["medium", "high"]);
